require("./blockmapsfonts.js");

require('./lightbox.js');

require('./swiper.min.js');

require('./swiper.js');

require('./popup.js');

require('./scrolled.js');

require('./map.js');

require('./referenzen.js');

require('./akkordeon.js');

require('./tabElement.js');

require('./umsatzPotential.js');

require('./navigation.js');

const AOS = require("aos");


document.addEventListener("DOMContentLoaded", () => {
    AOS.init({
        duration: 600,
        easing: 'ease-out-sine',
    });

   
    document.querySelectorAll("img").forEach(img => {
        img.addEventListener("load", () => {
            AOS.refresh();
        });
    });
});
